import type { Parcel, Person } from '@coig/apm-api';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { IonButton, IonCard, IonCardContent, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonSelect, IonSelectOption, IonToast } from '@ionic/react';
import { addCircle, cardOutline } from 'ionicons/icons';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { packageManagmentServices } from '../../services/packageManagmentServices';
import { useRequireAuth } from '../../utilities/authorization';
import { isCapacitorPluginUnimplementedException } from '../../utilities/plugins';
import './NewPackage.css';

const newPackage: React.FC = () => {
  useRequireAuth();

  const [name, setName] = useState<string | null>();
  const [description, setDescription] = useState<string | null>();
  const [successToast, setShowSuccessToast] = useState(false);

  const history = useHistory();
  const getScan = async () => {
    try {
      return await BarcodeScanner.scan();
    } catch (e: unknown){
      if (isCapacitorPluginUnimplementedException(e)){
        // eslint-disable-next-line no-console
        console.warn('Barcode Scanner plugin is unavailable', e);
        return Promise.resolve({text: 'P2-702135d3-3d68', format: 'QR_CODE', cancelled:false });
      } else {
        throw e;
      }
    }
  };
  const addPackage = async () => {
    const data = await getScan();

    if (!name || !description) {
      return;
    }
    const newPackage: Parcel = {
      id: data.text as Parcel['id'],
      parcelName: description,
      receiver: {
        name: name.split(' ').slice(0, -1).join(' '),
        surname: name.split(' ').slice(-1).join(' ')
      } as Person,
      status: 'READY_TO_SEND',
      size: 'HUGE',
      parcelDeposited: false,
    };
    await packageManagmentServices.updatePackage(newPackage.id, {...newPackage, registrationTime: '', statusModificationTime: '',});
    navigator.vibrate(500);
    setShowSuccessToast(true);
    history.push('/sent-packages');
  };

  return (
    <IonCard>
      <IonCardContent className="content">
        <div className="package-data">
          <div className="icon-text">
            <IonIcon slot='start' className="add-icon" icon={addCircle}/>
            <IonLabel>Parcel</IonLabel>
            <IonSelect interface="popover" value="wien-1">
              <IonSelectOption value="wien-1">Wien Landstraße</IonSelectOption>
            </IonSelect>
          </div>
          <div className="icon-text">
            <IonIcon slot='start' className="add-icon" icon={addCircle}/>
            <IonLabel>Recipient</IonLabel>
            <IonInput placeholder='John Smith' onIonChange={(event) => setName(event.detail.value)}/>
          </div>
          <div className="icon-text">
            <IonIcon slot='start' className="add-icon" icon={addCircle}/>
            <IonLabel>Description</IonLabel>
            <IonInput placeholder='Electric scooter' onIonChange={(event) => setDescription(event.detail.value)}/>
          </div>
        </div>
        <div className="payment-data">
          <IonButton expand='full'>Choose payment <IonIcon icon={cardOutline}/></IonButton>
        </div>
        <div className="package-size">
          <h3>Choose size:</h3>
          <div className="package-size-pick">
            <div className='package package-small'>
              <img src='assets/package.jpg' alt='package small' />
              <IonButton>
                small<br/>
                12x15x5cm
              </IonButton>
            </div>
            <div className='package package-medium'>
              <img src='assets/package.jpg' alt='package medium' />
              <IonButton>
                medium<br/>
                12x15x5cm
              </IonButton>
            </div>
            <div className='package package-large'>
              <img src='assets/package.jpg' alt='package large' />
              <IonButton>
                large<br/>
                12x15x5cm
              </IonButton>
            </div>
          </div>
          <IonButton className="confirm-button" expand="block" onClick={addPackage}>
            Add package
          </IonButton>
        </div>
      </IonCardContent>
      <IonToast
        isOpen={successToast}
        message='Your package has been added successfully'
        position='bottom'
        color='dark'
        duration={3000}
      />
    </IonCard>
  );
};

export { newPackage as NewPackage };
